import { forwardRef, useId } from 'react';

const Textarea = forwardRef(function Textarea(
  { label, error, id, rows = 4, maxLength, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? `ta-${autoId}`;
  const describedBy = error ? `${inputId}-err` : undefined;

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-text">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={inputId}
        rows={rows}
        maxLength={maxLength}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={describedBy}
        className={`rounded-md border bg-bg px-3 py-2 text-text font-body placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent ${
          error ? 'border-error' : 'border-border focus:border-accent'
        }`}
        {...rest}
      />
      {error && (
        <span id={describedBy} className="text-xs text-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
});

export default Textarea;
